import { Zap } from "lucide-react";
import { useApp } from "../context/AppContext";
import { useFetch } from "../lib/api";
import { PageHeader, Loading, Empty } from "../components/bits";
import { MissionCard } from "../components/MissionCard";

export default function Missions() {
  const { sp, isManager } = useApp();
  const { data } = useFetch(sp("/missions"), 15000);
  const list = data ? [...data].sort((a, b) => {
    const rank = (m) => (m.state === "open" || m.is_mine ? 0 : m.state === "filled" ? 1 : 2);
    return rank(a) - rank(b) || (rank(a) === 2 ? b.date.localeCompare(a.date) : 0);
  }) : null;
  return (
    <div data-testid="missions-page">
      <PageHeader title="Missions" />
      {!list ? <Loading /> : list.length === 0 ? (
        <Empty icon={Zap} text={isManager ? "Aucune mission à venir. Touchez « + Mission » pour en publier une." : "Aucune mission pour le moment."} />
      ) : (
        <div className="space-y-3">{list.map((m) => <MissionCard key={m.id} m={m} />)}</div>
      )}
    </div>
  );
}
